import { Pipe, PipeTransform } from '@angular/core';
import { IntegrationName } from '@app/modules/smart-devices/data/smart-devices.interface';

@Pipe({
  standalone: false,
  name: 'smartDeviceIntegrationImage',
})
export class SmartDeviceIntegrationImagePipe implements PipeTransform {
  transform(value: IntegrationName): string {
    return `/assets/images/smart-devices/integrations/${value}-circle.svg`;
  }
}
